/**
 * Shared Store Constants
 *
 * Neutral location for constants shared across multiple Zustand stores.
 * Avoids store→store coupling (e.g. useTabStore importing from useVisualizerStore).
 *
 * @see docs/Roadmap.md Item 1.16
 */

import type { PanelVisualizerConfig,VisualizerModifiers } from '@/store/useVisualizerStore';

export const DEFAULT_VISUALIZER_MODIFIERS: VisualizerModifiers = {
  syntaxHighlighting: true,
  lineNumbers: false,
  wordWrap: true,
};

export const DEFAULT_PANEL_CONFIG: PanelVisualizerConfig = {
  mode: 'raw',
  modifiers: { ...DEFAULT_VISUALIZER_MODIFIERS },
  modeSpecificState: {},
};

/**
 * Config keys that may contain secrets and should be stripped on persist.
 * Add new secret-bearing tool config field names here as tools are added.
 *
 * Known sources:
 * - `secretKey` — HmacGeneratorTool
 */
export const SENSITIVE_CONFIG_KEYS: ReadonlySet<string> = new Set([
  'secretKey',
]);
